import { House } from "lucide-react";
import { Link } from "react-router-dom";

export const Brand = ({ testId = "brand-home-link" }) => <Link to="/" className="brand" data-testid={testId} aria-label="kamerbooking accueil">
  <span className="brand-mark"><span>K</span><House/></span><span>kamerbooking<small>by YAYA</small></span>
</Link>;